import { connect } from 'react-redux';
import { change, Field } from 'redux-form';
import { useState } from 'react';
import { useProperty, useValidation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { ProductCardLayoutType, ProductCardModalType } from '../../../models/product';
import { useProductCardContext } from '../../../context/ProductCardContext';
import { formatGet, formatSet } from '../../../../single-choice/utils/format';
import ProductModal from '../../../components/ProductModal';
import SingleChoiceToggleBar from './SingleChoiceToggleBar';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const {
  Small: SMALL_CARD_LAYOUT,
  Main: MAIN_CARD_LAYOUT
} = ProductCardLayoutType;
function isTravelerNew(sellSpecification) {
  return sellSpecification.__typename === 'SellSpecificationTravelerNew';
}
const SingleChoiceOptions = {
  Decline: 0,
  Confirm: 1
};
const getAncillaryRadioOption = (productName, label, value) => ({
  'data-testid': `${productName}--${value}`,
  id: `${productName}_${value}`,
  label,
  value
});
const SingleChoiceField = _ref => {
  var _p, _p2;
  let {
    dispatch,
    onChange
  } = _ref;
  const {
    p
  } = useProperty();
  const [isOpen, setIsOpen] = useState(false);
  const {
    priceRaw,
    extraProps,
    productCardModal,
    title,
    form = '',
    productName,
    sellSpecification,
    modalText,
    productId,
    layoutType
  } = useProductCardContext();
  const {
    labelNo,
    labelYes,
    onButtonChange,
    normalize,
    selectOneLabel
  } = extraProps;
  const validate = useValidation(productName);
  const normalCardProductsExcludedFromValidation = (_p = p('TravelerDetails.NormalCardProducts.ExcludedFromValidation')) !== null && _p !== void 0 ? _p : [];
  const smallCardProductsExcludedFromValidation = (_p2 = p('TravelerDetails.SmallCardProducts.ExcludedFromValidation')) !== null && _p2 !== void 0 ? _p2 : [];
  const shouldDisableValidation = layoutType === MAIN_CARD_LAYOUT && normalCardProductsExcludedFromValidation.includes(productId) || layoutType === SMALL_CARD_LAYOUT && smallCardProductsExcludedFromValidation.includes(productId);
  const fieldsetLegend = shouldDisableValidation ? '' : selectOneLabel;
  analytics.useLogMouseFlowTagEffect(`steering validation`, shouldDisableValidation);
  const buttonOptions = [getAncillaryRadioOption(productName, labelNo, 'false'), getAncillaryRadioOption(productName, labelYes, 'true')];
  const hasModal = Boolean(productCardModal && productCardModal.type !== ProductCardModalType.None && productCardModal.content);
  const handleChange = e => {
    const value = e === null || e === void 0 ? void 0 : e.target.value;
    if (onButtonChange) {
      onButtonChange(value);
    }
    if (onChange && value) {
      onChange(value);
    }
    if (sellSpecification && isTravelerNew(sellSpecification)) {
      const travelerIds = sellSpecification.sellPriceTravelers.flatMap(t => t ? t.travelerId : []);
      dispatch(change(form, productName, {
        travelerIds
      }));
    }
    if (hasModal) {
      const openModalOnAccept = (productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.type) === ProductCardModalType.Confirmation && value === 'true';
      const openModalOnDecline = (productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.type) === ProductCardModalType.Persuasion && value === 'false';
      setIsOpen(openModalOnAccept || openModalOnDecline);
    }
  };
  const modalAction = option => {
    const {
      value
    } = buttonOptions[option];
    dispatch(change(form, `${productName}.value`, {
      value,
      priceRaw
    }));
    setIsOpen(false);

    // Move focus to appropriate button on modal closed
    const productRadioButton = document.querySelector(`#${productName}_${value}`);
    if (productRadioButton) {
      setTimeout(() => {
        productRadioButton.focus();
      }, 400);
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Field, {
      className: "singleChoice",
      component: SingleChoiceToggleBar,
      form: form,
      format: formatGet,
      legend: fieldsetLegend,
      name: `${productName}.value`,
      normalize: normalize || formatSet(priceRaw),
      onChange: handleChange,
      options: buttonOptions,
      priceRaw: priceRaw,
      validate: shouldDisableValidation ? undefined : validate
    }), hasModal && /*#__PURE__*/_jsx(ProductModal, {
      confirmText: modalText === null || modalText === void 0 ? void 0 : modalText.confirmText,
      content: productCardModal === null || productCardModal === void 0 ? void 0 : productCardModal.content,
      declineText: modalText === null || modalText === void 0 ? void 0 : modalText.declineText,
      isOpen: isOpen,
      onConfirm: () => modalAction(SingleChoiceOptions.Confirm),
      onDecline: () => modalAction(SingleChoiceOptions.Decline),
      productName: productName,
      title: title
    })]
  });
};
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(null, mapDispatchToProps)(SingleChoiceField);
//# sourceMappingURL=SingleChoiceField.js.map